import React from "react";
import FileScannerComponent from "./form-input-scanner-and-file"

export default (props) =>{
    return <FileScannerComponent {...props}/>
}
